"use client";

import React, { useMemo } from "react";

import PortfolioRewardsAtomClaim from "@/components/Portfolio/Rewards/Atom/Claim";
import LayoutNavBarItem from "@/components/Layout/NavBar/Item";

import { usePathname } from "next/navigation";

import useProtocolRewardsClaimable from "@/hooks/rewards/useProtocolRewardsClaimable";

export default function LayoutNavBarPortfolio() {
  const pathname = usePathname();

  const { isActivePositions, isActiveRewards, isActiveActivity, isActiveMigrate } = useMemo(
    () => ({
      isActivePositions: pathname.endsWith("portfolio/"),
      isActiveRewards: pathname.includes("portfolio/rewards"),
      isActiveActivity: pathname.startsWith("/activity/"),
      isActiveMigrate: pathname.startsWith("/migrate/"),
    }),
    [pathname]
  );

  const { data: protocolClaimableRewardsData, isLoading } = useProtocolRewardsClaimable("cached");

  return (
    <nav className="custom-scrollbar min-w-screen relative -bottom-[1px] inline-flex h-14 min-h-[56px] w-full items-stretch justify-between overflow-x-scroll md:min-w-0 md:overflow-x-auto">
      <div className="flex items-center space-x-3">
        <LayoutNavBarItem isActive={isActivePositions} link="/portfolio/">
          Positions
        </LayoutNavBarItem>
        <LayoutNavBarItem isActive={isActiveRewards} link="/portfolio/rewards/">
          Rewards
        </LayoutNavBarItem>
        <LayoutNavBarItem isActive={isActiveMigrate} link="/migrate/">
          Migrate
        </LayoutNavBarItem>
        <LayoutNavBarItem isActive={isActiveActivity} link="/activity/">
          Activity
        </LayoutNavBarItem>
      </div>
      {isActiveRewards && (
        <div className="ml-5 flex items-center space-x-4 md:ml-0">
          <PortfolioRewardsAtomClaim isLoading={isLoading} rewardsClaimable={protocolClaimableRewardsData?.rewards} />
        </div>
      )}
    </nav>
  );
}
